import React from 'react';

import { View, Text, StyleSheet } from 'react-native';

import {
  OPComponent,
  Container,
  I18n,
  ProfileAvatar,
  Navigation,
  DateUtils,
  IconRow,
} from '../../components';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../../constants/styles';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  getEditingCase,
  getEditingCasePatient,
  getEditingCaseEmployer,
  getEditingCasePatientProfile,
  getEditingCasePatientEmployerUser,
} from '../../cases/selector';

import { getEditingPatientDeploymentInfo } from '../../patient/selector';

import { INVITATIONS, PATIENT_INFO, RESIDENT_ADMINISTRATION } from '../../../constants/permissions';
import { editingCasePermissions } from '../../../helpers/permissions';

import ResendPatientInvite from '../../invite/resend_patient_invite';
import PatientInfo from '../../patient/airforce/patient_info';

import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../../actions/statusTypes';

class CaseInfoAirforce extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      resendPatientInviteError: null,
      resendPatientInviteStatus: null,
      sendSuccessMessage: null,
      atLeastOneFormSaved: false,
    };
  }

  componentDidMount() {}
  componentWillUnmount() {}
  componentDidUpdate(prevProps, prevState) {}

  handleResendPatientInviteStatus = (resendPatientInviteStatus) => {
    this.setState({
      resendPatientInviteStatus,
    });
  };
  handleResendPatientInviteError = (resendPatientInviteError) => {
    this.setState({ resendPatientInviteError });
  };
  handleResendPatientInviteSuccess = (sendSuccessMessage) => {
    this.setState({ sendSuccessMessage });
  };

  _goToSubScreen = (screenName, title, passProps) => {
    if (screenName === 'PatientMedicalClearance') {
      this.props.onEdit?.();
    }
    Navigation.push(
      {
        screen: screenName,
        title: title,
        passProps,
      },
      this.props.componentId
    );
  };

  render() {
    const props = this.props;

    if (!props.canViewEditingCase) return null;

    const successMessage = this.state.sendSuccessMessage || this.props.caseCreateSuccessMessage;
    const errorMessage = this.state.resendPatientInviteError;

    const imageSource = require('../../../../resources/icon-airforce.png');

    const roleDescription = props.employerUser?.role || props.editingCasePatient.role;

    return (
      <Container
        actionSheet={true}
        scrollView={true}
        renderActivityOverlay={
          !props.editingCase || this.state.resendPatientInviteStatus === REQUESTING
        }
        successMessage={successMessage}
        errorMessage={errorMessage}
      >
        <View style={styles.header}>
          <ProfileAvatar initialsStr={props.editingCase.name} profile={props.patientProfile} />
          <Text style={styles.headerText}>{props.editingCase.name}</Text>
          {!!props.deploymentInfo && (
            <Text style={styles.readinessText}>
              Readiness Date:{' '}
              <Text style={{ ...FONT.semibold }}>
                {DateUtils.formatDateStringNumeric(props.deploymentInfo.date, null, {
                  padDigits: true,
                })}
              </Text>
            </Text>
          )}
        </View>

        <ResendPatientInvite
          editingCase={props.editingCase}
          editingCasePatient={props.editingCasePatient}
          canEditInvites={props.canEditPatientInvites}
          editingCaseEmployer={props.editingCaseEmployer}
          onStatus={this.handleResendPatientInviteStatus}
          onError={this.handleResendPatientInviteError}
          onSuccess={this.handleResendPatientInviteSuccess}
        />

        <IconRow
          imageSource={imageSource}
          label={roleDescription ? `${roleDescription}` : I18n.aec('case.residentOf')}
          value={props.editingCaseEmployer.name}
          topBorder={true}
          bottomBorder={false}
        />

        <PatientInfo
          employer={props.editingCaseEmployer}
          case={props.editingCase}
          patient={props.editingCasePatient}
          goToSubScreen={this._goToSubScreen}
        />
      </Container>
    );
  }
}

const styles = StyleSheet.create({
  header: {
    ...THEME.header,
    alignItems: 'center',
  },
  headerText: {
    ...THEME.headerText,
    marginTop: 10,
  },
  readinessText: {
    ...THEME.textRegular,
    marginTop: 10,
  },
});

function mapStateToProps(state, ownProps) {
  return {
    editingCaseEmployer: getEditingCaseEmployer(state),
    editingCase: getEditingCase(state),
    editingCasePatient: getEditingCasePatient(state),
    canViewEditingCase: editingCasePermissions(RESIDENT_ADMINISTRATION).canView,
    canEditPatientInvites: editingCasePermissions(INVITATIONS).canEdit,
    deploymentInfo: getEditingPatientDeploymentInfo(state),
    patientProfile: getEditingCasePatientProfile(state),
    employerUser: getEditingCasePatientEmployerUser(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({}, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CaseInfoAirforce);
